<template>
  <div>
      <div>
        <div class="agreement-container">
          <h2 class="title">众筹活动用户协议</h2>
          <p style="float: right">生效日期：2023年5月1日</p>
          <p>&nbsp;</p>
          <p class="p-text">本协议已对与您（指拟使用e农农服平台（以下称“平台”）支持众筹项目的用户）的权益有或可能具有重大关系的条款，及e农农服平台的运营、管理主体华农农服（北京）网络科技有限公司（以下称“我们”）具有或可能具有免责或限制责任的条款予以标注。 如果您对本协议的条款有疑问的，请通过我们服务渠道进行询问，我们将向您解释条款内容。在您接受本协议约定由我们提供的服务时（以下称“本服务”）时，您已充分阅读、理解并接受本协议的全部内容（特别是以粗体标注的内容），一旦您使用本服务，即表示您同意遵循本协议之所有约定。</p>
          <p class="bold">1. 定义和解释</p>
          <p>除非本协议正文另有明确所指，在本协议中所用下列术语定义如下:</p>
          <p>1）e农农服平台：是指华农农服（北京）网络科技有限公司经营的电商平台，包括但不限于e农网站（www.e-nongye.com.cn)、e农客户端及 e农微信商城。本协议中称“平台”。</p>
          <p>2）众筹：指发起人与支持者共同完成项目的行为,在这一过程中支持者出资支持发起人在平台发起的众筹项目，发起人完成项目并按承诺向支持者发放众筹产品。</p>
          <p>3）众筹项目：指发起人依据我们于平台发布的众筹规则的要求，通过平台发布相应项目的众筹需求并按要求募集资金，并依据我们发布的众筹规则进行收款及发货的产品经营活动。</p>
          <p>4）众筹产品：指发起人拟筹款完成的众筹项目面向支持者的众筹回报，即发起人生产、销售、配送的实物产品，本协议中称为“众筹产品”或“产品”。</p>
          <p>5）发起人：指在平台上发起项目的自然人、法人或其他组织，本协议中可称为“您”。发起人于平台依法开展经营活动，独立进行订单处理、物流配送、售后服务，对其在平台的经营活动独立承担法律责任。</p>
          <p>6）支持者：指对发起人发起的众筹项目表示支持的我们用户，即您。支持者通过支付一定金额众筹支持款项的方式，取得众筹项目的项目成果及/或相关产品。本协议中称“您”或“支持者”。支持者应当是具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您应当在您的合法监护人的参与及许可下使用平台服务，您及您的合法监护人应依照法律规定承担因此而导致的一切后果。</p>
          <p>7）关联公司/机构：指与某一自然人、法人、非法人组织存在股权、控制权、管理权等层面的关联关系的法人或非法人组织。</p>
          <p>8）首付款：指发起人在产品发货前先行收到的款项。</p>
          <p>9）尾款：指发起人在完成全部产品发货行为后收到的款项。</p>
          <p>10）众筹期限：指发起人在平台公布的众筹项目募集款项的时间。</p>
          <p>11）募集总金额：指众筹期限届满时，发起人发起的众筹项目所募集的款项总额。</p>
          <p>12）众筹成功：指在发起人设定的众筹期限内，募集总金额达到或超过了发起人设定的目标筹款金额。</p>
          <p>13）众筹失败：指众筹出现下列情形之一：</p>
          <p>&nbsp;&nbsp;1.众筹募集失败，即众筹期限届满但未达到预定募集金额，但平台发布的规则及其他文件另有约定的情形除外；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;i.发起人由于能力限制、市场风险、法律风险等各种因素，在众筹期限届满前取消项目。</p>
          <p>14）项目成功结束：指发起人向支持者完成所有众筹产品的发货且全部支持者均已完成确认收货之日。</p>
          <p class="bold">2. 签约主体和效力范围</p>
          <p>1）为了规范发起人使用平台的各项行为，明确发起人及支持者的权利义务，保障您和支持者的合法权益，特拟定本协议，本协议由作为发起人的您与我们共同签署。</p>
          <p class="p-text">2）您通过网络页面点击确认或以其他方式选择接受本协议，即表示您与我们已达成协议并同意接受本协议的全部约定内容。本协议自您通过网络页面点击确认或以其他方式选择接受本协议之时起生效。</p>
          <p class="p-text">3）我们可不时修改本协议及相关规则，如本协议及相关规则有任何变更，我们将在平台上以公示形式通知。公示时间（以下称“公示期”）将不少于7日。在公示期内，您可通过平台中公布的联系方式向我们反馈您对修改内容的意见及建议，我们将充分考虑。修改后的协议及规则将自公示期满之日的次日生效并实施，并成为本协议的补充协议或替代本协议发生效力。如您继续登录或使用平台的，即视为您已阅读并接受修改后的协议及规则。</p>
          <p class="bold">3. 支持者言论规范</p>
          <p>1）本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;i. 不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;ii.  从中国大陆向境外传输资料信息时必须符合中国有关法规；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;iii．不得利用平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;iv. 不得干扰平台的正常运转，不得侵入平台及国家计算机信息系统；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;v. 不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;vi. 不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;vii. 不得教唆他人从事本条所禁止的行为；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;viii. 不得利用在平台注册的账户进行牟利性经营活动；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;ix. 不得发布任何侵犯他人隐私、个人信息、著作权、商标权等知识产权或合法权利的内容；</p>
          <p>2）您须对自己在平台上的言论和行为承担法律责任，您若在平台上散布和传播反动、色情或其它违反国家法律的信息，平台的系统记录有可能作为您违反法律的证据。</p>
          <p class="bold">4. 众筹项目支持规则</p>
          <p>1）发起人在e农平台发起众筹项目，在项目页面注明筹款期限、预定募集金额等信息，您点击“立即支持”按钮，或发起人及(或）我们另行指示的其他按钮进行支持，您提交订单成功即与发起人达成众筹合同。众筹成功后，发起人按约定在承诺时间内向支持者发放众筹产品、按承诺承担后续服务。</p>
          <p>2）发起人将在项目页面实时更新项目进展，以便您了解项目进展。</p>
          <p>3）若众筹项目失败，您支付的款项将退还至您的原支付账户。</p>
          <p class="bold">5. 个人信息</p>
          <p class="p-text">1）鉴于众筹业务的特点，我们需要获取您的个人信息 （包括但不限手自然人的姓名、身份证件号码、住址、电话号码、银行账号等信息)，并提供给发起人以便完成处理退款等众筹项目的使用。</p>
          <p class="p-text">2）保护用户隐私是e农平台的一项基本政策，我们保证不对外公开或向第三方提供您的个人信息及您在使用网络服务时存储在e农平台平台的非公开内容，但下列情况除外：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">i. 事先获得您的授权；</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">ii. 根据有关的法律法规要求;</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">iii．按照相关政府主管部门、司法机关的要求;</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">ix. 为维护我们的合法权益。</span></p>
          <p class="bold">6. 违约责任</p>
          <p class="p-text">1）如果我们发现或收到他人举报投诉您违反本协议约定的，我们有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁直至注销的处罚，并公告处理结果。</p>
          <p class="p-text">2）我们有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。</p>
          <p class="p-text">3）您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任;因此造成我们遭受任何损失的，您也应当一并赔偿。</p>
          <p class="p-text">4）除非另有明确的书面说明,我们不对平台的运营及其包含在平台上的信息、内容、材料、产品或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。</p>
          <p class="bold">7. 其它</p>
          <p class="p-text">1）众筹有效期为: 最长时间不超过45天，详情以活动页面时间为准。</p>
          <p class="p-text">2）众筹成功</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">i. 众筹有效期内，达成相应活动目标，活动结束后30天内按对应规格进行发货。</span></p>
          <p class="p-text">3）众筹失败</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">i. 超过众筹有效期，未达成相应活动目标，则该众筹活动失败。</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">ii. 超过众筹有效期，支持者确认商品合同或其它文本未达到众筹总量的70%，则该众筹活动失败。</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">iii. 众筹失败的订单，系统会在3个工作日内原路退回。</span></p>
          <p class="p-text">4）如何退款</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">i. 众筹活动进行中订单不能进行退款。</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">ii. 众筹活动后成功支付尾款，已经确认商品合同及其他文本的订单不能申请退款。</span></p>
          <p class="p-text">5）购买次数</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">i. 单个众筹活动，每位支持者限购一次。</span></p>
          <p class="p-text">6）服务费</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">i. 支持者需支付发起人众筹服务费用，收取标准为每笔1%-5%。</span></p>
          <p class="p-text">7）敬请注意</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">i. 众筹活动成功后，请仔细阅读商品合同或其它文本。</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">ii. 众筹活动成功后，发起人上传商品合同或其它文本，支持者接受众筹结果并充分了解商品合同或其它文本并确认（您点击“确认”按钮，或发起人及(或）我们另行指示的其他按钮进行确认）后，该众筹确认支持者达该众筹支持者总量的70%后，则视为该众筹有效，支持者应付第二笔款项，发起人在确认第二笔款项后，发起人上传支付凭证（支付凭证指发起人与厂家或其它生产商之间的支付凭证，包括发起人支付凭证与厂家或其它生产商的收款凭证等）后，支持者应支付尾款，尾款需在最晚交货期之前，支付尾款，如未支付，则为违约，订单不能进行退款。</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">iii. 众筹活动成功后，支持者不接受众筹结果、商品合同或其它文本，订单可申请退款，系统处理后会在3个工作日内原路退回。</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">iv. 众筹订单不参加促销活动; 众筹活动存在订单量过大，支持者范围广等原因，众筹活动均在众筹成功并支付尾款后陆续发货。</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;<span class="p-text">v. 因不可抗力或情势变更导致的问题(包括但不限于因重大自然灾害、国家法律法规、政策调整或网络攻击需暂停活动等原因无法参加活动等)，活动将临时暂停或终止，请您注意。</span></p>
          <p>8）您应该提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），如您的联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使通知无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</p>
          <p>9）我们可向您浏览的页面推送弹窗等形式的通知或向您的上述联系方式的其中之一或其中若干送达各类通知，此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。</p>
          <p>10）如果本协议的部分条款被争议解决机构认定为违法，则并不影响其他条款的有效性。</p>
          <p>11）e农平台指定邮箱【enongye@aliyun.com】。</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  methods:{
      closeEvent(){
        window.opener=null;
        window.close();
      }
  }
}
</script>

<style lang="scss">

.agreement-container{
  margin-top: 21px;
  border: 1px #e4e4e4 solid;
  background: #fff;
  padding: 0 40px 0 40px;
  p{
    line-height: 30px;
    font-size:14px;
    color:#666;
    word-break: break-all;
  }
  h2{
    padding:60px 0 40px;
    text-align: center;
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight: 700;
    font-size: 20px;
  }
  .bold{
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight:700;
    color:#1ABC9C;
    line-height: 76px;
  }

  .p-text {
    text-decoration:underline;
    font-size:14px;
    font-weight:bold;
  }
  .p-t {
    font-size:14px;
    font-weight:bold;
  }

  .p-n {
    text-decoration:underline;
  }
}
.link{
  cursor: pointer;
  .fa-close{
    margin-right: 5px;
    font-size: 16px;
    color: #1ABC9C;
  }
}
</style>
